import { useSegment } from '@telialt/utils/src/segment';

import { apiAddGifts } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useAddGiftsMutation = () => {
    const segment = useSegment();
    const { cartId } = useCartQuery();
    const { mutate, isPending, error } = useMutationWithCartRefresh(async (giftCodes: string[]) => {
        const { data: cart } = await apiAddGifts(segment, { cartId }, giftCodes);

        return cart;
    });

    return {
        addGifts: mutate,
        addGiftsIsLoading: isPending,
        addGiftsError: error,
    };
};
